<template>
  <div class="page-shell-wrapper">
    <HeadNav :locale="locale" />
    <main class="page-shell">
      <h1 v-if="pageTitle && !hideTitle" class="page-shell__title">{{ pageTitle }}</h1>
      <slot />
    </main>
  </div>
</template>

<script>
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'PageShell',
  components: {
    HeadNav,
  },
  props: {
    locale: {
      type: String,
      default: 'id',
    },
    pageTitle: {
      type: String,
      default: '',
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
